import { Component } from "react";
import View from "./view";
import "./index.css";

class HomeScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return View.call(this);
  }
}

export default HomeScreen;



// WEBPACK FOOTER //
// ./src/screens/machines/index.js